// Brief 85 §2 — AdditionalPartyModal, moved out of App.tsx's renderModals switch.
//
// MOVED, NOT REWRITTEN. The body below is byte-identical to the `case "op2":`
// clause it left —
//   sha256 c7d0dc2020ccf5785e8b2befba13eb82d366bce0ca57334868543552e192de7d
// — including its original indentation, which is why it sits deeper than this
// file's own wrapper. Only the imports, the Props type, the signature and the
// `return (` / `);` are new.
// Do not reformat: the indentation IS the proof.
//
// Props are the UNION of the names the body actually read in App scope, taken
// from a TypeScript-checker walk rather than chosen — a passed-but-unread prop
// would mean the union rule absorbed something it should have refused.
// The vocabulary props are typed by inference off makeModalFields' return, so
// this file adds nothing to the `any` ratchet.

import AddressFields from "./AddressFields";
import { ModalLayout } from "../SharedUI";
import { SK } from "../../utils";
import type { TaxList, TFn } from "../../lib/taxonomyTypes";
import type { FieldSelectOption } from "../FieldSelect";
import type { makeModalFields } from "../modalFields";

type Vocab = ReturnType<typeof makeModalFields>;
type ModalForm = { country?: string | null; id?: string | null };

type Props = {
  BarAssoc: Vocab["BarAssoc"];
  F: Vocab["F"];
  NA: Vocab["NA"];
  T: Vocab["T"];
  TitSel: Vocab["TitSel"];
  _fl: Vocab["_fl"];
  _mt: Vocab["_mt"];
  additionalOpponents: readonly unknown[];
  clients: readonly unknown[];
  cm: () => void;
  countriesList: readonly FieldSelectOption[];
  countryEntries: TaxList;
  form: ModalForm;
  saveEntityGuarded: (k: string, rows: readonly unknown[], set: (v: readonly unknown[]) => void, f: unknown, ext?: Record<string, unknown>) => void;
  setAdditionalOpponents: (v: readonly unknown[]) => void;
  t: TFn;
  updateField: (k: string, v: string) => void;
};

export default function AdditionalPartyModal({
  BarAssoc,
  F,
  NA,
  T,
  TitSel,
  _fl,
  _mt,
  additionalOpponents,
  clients,
  cm,
  countriesList,
  countryEntries,
  form,
  saveEntityGuarded,
  setAdditionalOpponents,
  t,
  updateField,
}: Props) {
  return (
          <ModalLayout
            recordId={form.id} // 204 §G — the person's internal id in the header
            title={form.id ? _mt("Edit Person") : _mt("New Person")}
            onClose={cm}
            onSave={() =>
              saveEntityGuarded(SK.op2, additionalOpponents, setAdditionalOpponents, form, {
                country: form.country || null,
              })
            }
          >
              <>
                <div className="field-row">
                  {TitSel}
                  {F("First Name *", "firstName", "", 1)}
                </div>
                <div className="field-row">
                  {F("Last Name *", "lastName")}
                  {F("Specialty", "specialty")}
                </div>
                {NA({
                  pool: additionalOpponents,
                  coiPool: clients,
                  typeLabel: t("type.additional_opponent", {
                    fallback: "additional opponent",
                  }),
                })}
                {F("Organisation", "firm")}
                <div className="field-row">
                  {F("Email", "email")}
                  {F("Phone", "phone")}
                </div>
                {BarAssoc}
                <AddressFields
                  F={F}
                  _fl={_fl}
                  countriesList={countriesList}
                  countryEntries={countryEntries}
                  form={form}
                  t={t}
                  updateField={updateField}
                />
                {T("Notes", "notes")}
              </>
          </ModalLayout>
  );
}
